export default __webpack_public_path__ + "images/CG.2715b7e.png";